export const isCurrentPage = (...urlSegments: Array<string>): boolean =>
	urlSegments.reduce<boolean>((acc, curr) => {
		const tmp = window.location.href.includes(curr);
		return acc && tmp;
	}, true);
